import {Component, OnInit} from '@angular/core';
import {Game, GameType} from '../../domain/game';
import {Router} from '@angular/router';
import {GameService} from '../game.service';
import {Gender} from '../../domain/player';

@Component({
  templateUrl: './preparation.component.html',
  styleUrls: ['./preparation.component.scss']
})
export class PreparationComponent implements OnInit {

  step = 0;
  todayDate: Date;
  todaystring: string;
  aantalSpelers: number;

  // game: Game = {
  //   players: [],
  // };

  game: Game = {
    players: [
      {name: 'Walter', age: 57, anxChoice: 3, anxChoiceAfter: null, avatarIcon: 3, gender: Gender.male, wisdomCards: 0},
      {name: 'Gemma', age: 53, anxChoice: 4, anxChoiceAfter: null, avatarIcon: 2, gender: Gender.female, wisdomCards: 0},
      // {name: 'Arjan', age: 60, anxChoice: 5, anxChoiceAfter: null, avatarIcon: 7, gender: Gender.other, wisdomCards: 5},
      // {name: 'Arne', age: 51, anxChoice: 2, anxChoiceAfter: null, avatarIcon: 1, gender: Gender.male, wisdomCards: 0},
      // {name: 'Anna', age: 47, anxChoice: 5, anxChoiceAfter: null, avatarIcon: 4, gender: Gender.male, wisdomCards: 0},
      // {name: 'Klaas-Jolle', age: 60, anxChoice: 1, anxChoiceAfter: null, avatarIcon: 9, gender: Gender.male, wisdomCards: 0}
    ],
    type: null,
    activationCode: '12345',
    numberOfRounds: 0,
    location: '',
    stellingScores: [],
  };

  constructor(
    private router: Router,
    private gameService: GameService) {
  }

// AANPASSING OM INEENS IN GAME TE KOMEN
  ngOnInit() {
    // this.startGame();
  }

  startGame() {
    // VOEG SPELGEGEVENS TOE
    this.todayDate = new Date();
    this.todaystring = this.todayDate.toLocaleDateString();
    this.game.gameDate = this.todaystring;
    this.game.numberOfRounds = 0;
    this.game.stellingScores = [];

    // VOEG AANTAL SPELERS TOE
    this.aantalSpelers = this.game.players.length;
    this.game.numberOfPlayers = this.aantalSpelers;

    // CREËER GAME EN START
    this.gameService.createGame(this.game).subscribe(
      game => {
        this.game = game;
        this.router.navigate(['/', this.game.id]);
      },
      err => console.error('createGame failed', err)
    );
  }

}
